import styled from "styled-components";

const CommonSelectBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 2px;
  flex-grow: 1;
`;

export default CommonSelectBoxContainer;
